import { render, staticRenderFns } from "./visaworkpermit.vue?vue&type=template&id=2263a14c&scoped=true&"
import script from "./visaworkpermit.vue?vue&type=script&lang=js&"
export * from "./visaworkpermit.vue?vue&type=script&lang=js&"
import style0 from "./visaworkpermit.vue?vue&type=style&index=0&id=2263a14c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2263a14c",
  null
  
)

export default component.exports